import {GameClient} from "../../engines/managers/gameSocketManager";
import {$WS} from "../../WsSdk/webSocketProtocol/webSocketProtoHead";
import SCSubGameSync from "../../WsSdk/webSocketProtocol/wsInstanceList/SCSubGameSync";
import {managers} from "../../engines/gameEngine";
import FpsSyncListMsg from "../../WsSdk/webSocketProtocol/wsInstanceList/FpsSyncListMsg";
import CSubMatchRoom from "../../WsSdk/webSocketProtocol/wsInstanceList/CSubMatchRoom";
import SSubMatchRoom from "../../WsSdk/webSocketProtocol/wsInstanceList/SSubMatchRoom";
import SyncMessage from "../../WsSdk/webSocketProtocol/wsInstanceList/SyncMessage";
import comO1Box from "../../engines/components/comO1Box";
import fpsPlayer from "./prefab/fpsPlayer";
import SSubFpsGameStart from "../../WsSdk/webSocketProtocol/fpsGameList/SSubFpsGameStart";
import o1BoxManager from "../../engines/managers/o1BoxManager";
import {FpsSync} from "../../WsSdk/webSocketProtocol/fpsGameList/fpsSyncEnum";

const {ccclass, property} = cc._decorator;

export enum Direction {
    LEFT,
    RIGHT
}

@ccclass
export default class fpsMode extends cc.Component implements GameClient {

    //websocket
    readonly gameId: number = 102;
    readonly gameName: string = '帧同步demo';
    //时间
    private FRAME_TICK: number;
    //
    private m_currFrameTime: number;
    //
    protected m_timeCbNumber: number;

    private m_mePlayerSeat: number;

    protected onUpdateSync(): boolean {
        //new 
        for (let i = 0; i <= this.FRAME_TICK; i += o1BoxManager.UPDATE_TICK) {
            const dt = i;
            const {seat, list} = this.m_frameCurrMsg.body;
            if (seat.length > 0) {
                do {
                    const fi = seat[0];
                    const opera = list[0];
                    //操作完了
                    if (fi == null || opera == null) {
                        break;
                    }
                    //
                    const {fps, syncs} = opera;
                    //时间到了
                    if (dt >= fps) {
                        console.debug('执行命令', dt, fps, syncs);
                        this.onNetSyncOpera(fi, syncs);
                        seat.shift();
                        list.shift();
                    } else {
                        //时间未到，后面的都是时间未到的
                        break;
                    }
                } while (true);
            }
            managers().o1BoxMgr.onUpdate();
        }
        if (this.m_frameCurrMsg.body.list.length > 0) {
            console.error('#未预处理完的逻辑', this.m_frameCurrMsg.body);
        }
        return true;

        // //old 
        // //帧计时
        // this.m_currFrameTime += o1BoxManager.UPDATE_TICK;
        // const dt = this.m_currFrameTime;

        // //TODO:同步帧
        // const { seat, list } = this.m_frameCurrMsg.body;
        // if (seat.length > 0) {
        //     do {
        //         const fi = seat[0];
        //         const opera = list[0];
        //         //操作完了
        //         if (fi == null || opera == null) {
        //             break;
        //         }
        //         //
        //         const { fps, syncs } = opera;
        //         //时间到了
        //         if (dt >= fps) {
        //             this.onNetSyncOpera(fi, syncs);
        //             seat.shift();
        //             list.shift();
        //         } else {
        //             //时间未到，后面的都是时间未到的
        //             break;
        //         }
        //     } while (true);
        // }

        // //物理引擎驱动
        // managers().o1BoxMgr.onUpdate();

        // //帧结束
        // if (dt >= this.FRAME_TICK) {
        //     this.overFrame();
        //     return false;
        // }
        // return true;
    }

    protected onNetSyncOpera(i: number, opera: FpsSync[]) {
        const p = this.getPlayerOfSeat(i);
        switch (opera[0]) {
            case FpsSync.LEFT_DOWN: {
                this.onStartGo(Direction.LEFT, p);
                break;
            }
            case FpsSync.RIGHT_DOWN: {
                this.onStartGo(Direction.RIGHT, p);
                break;
            }
            case FpsSync.LEFT_UP: {
                this.onEndGo(Direction.LEFT, p);
                break;
            }
            case FpsSync.RIGHT_UP: {
                this.onEndGo(Direction.RIGHT, p);
                break;
            }
            case FpsSync.JUMP: {
                this.onJump(p);
            }
        }
    }

    setFrameTick(time: number) {
        this.FRAME_TICK = time;
    }
    protected predictFrame() {
        let t = Date.now();
        this.onUpdateSync();
        t = Date.now() - t;
        t && console.debug('time', t);
    }

    protected onJumpCurrFrame() {
        while(managers().o1BoxMgr.isHaveLastPos()){
            managers().o1BoxMgr.onTimerPredictSync();
        }
        this.overFrame();
    }

    startFrame() {
        this.m_currFrameTime = 0;
        this.predictFrame();
        this.m_timeCbNumber = setInterval(() => {
            managers().o1BoxMgr.onTimerPredictSync();
            if (!managers().o1BoxMgr.isHaveLastPos()) {
                this.overFrame();
            }
        }, o1BoxManager.UPDATE_TICK);
    }

    overFrame() {
        this.m_timeCbNumber && clearInterval(this.m_timeCbNumber);
        this.m_timeCbNumber = null;
        //TODO:帧结束
        this.m_frameCurrMsg.body.frame++;
    }

    sendGameMessage(cMsg: Uint8Array): void {
        managers().socketMgr.sendGameMessage(cMsg);
    }

    sendHallMessage(cMsg: $WS.WebSocketProtoHeadBody | Uint8Array): void {
        // managers().socketMgr.sendHallMessage(cMsg);
    }

    sendSyncMessage(msg: Uint8Array): void {
        managers().socketMgr.sendMessage(msg);
    }

    onGameMessage(head: number, body: Uint8Array): Promise<void> {
        switch (head) {
            case SSubMatchRoom.HEAD: {
                const msg = SSubMatchRoom.unPackageMessage(body);
                console.debug('用户进入', msg);
                break;
            }
            case SSubFpsGameStart.HEAD: {
                const msg = SSubFpsGameStart.unPackageMessage(body);
                this.onGameStart(msg);
                break;
            }
        }
        return Promise.resolve();
    }

    protected onGameStart(msg: SSubFpsGameStart) {
        console.debug('游戏开始', msg);
        this.setFrameTick(msg.body.frameTime);
        //
        for (let i = 0; i < msg.body.pUidList.length; i++) {
            if (msg.body.pUidList[i] == managers().socketMgr.getUserId()) {
                this.m_mePlayerSeat = msg.body.pSeatList[i];
            }
        }
        console.debug('我的座位号', this.m_mePlayerSeat);
    }

    onFpsGameSyncMessage(msg: FpsSyncListMsg): Promise<void> {
        const {seat, list, frame} = msg.body;
        if (seat.length > 0) {
            console.debug('收到帧同步', JSON.stringify(msg));
        }
        //同步
        this.onSyncFrame(msg);
        return Promise.resolve();
    }

    protected onSyncFrame(msg: FpsSyncListMsg) {
        //
        if (this.m_frameCurrMsg != null) {
            //
            if (this.m_frameCurrMsg.body.frame + 1 == msg.body.frame) {
                console.warn('TODO:跳当前帧');
                this.onJumpCurrFrame();
            } else if (this.m_frameCurrMsg.body.frame < msg.body.frame) {
                console.warn('需要跳过多帧', msg.body.frame - this.m_frameCurrMsg.body.frame);
            }
        }
        //
        this.m_frameCurrMsg = msg;
        //
        this.startFrame();
        //显示
        this.lbFrame.string = `${this.m_frameCurrMsg.body.frame}`;
    }

    onGameSyncMessage(msg: SCSubGameSync): Promise<void> {
        return Promise.resolve();
    }

    private m_frameCurrMsg: FpsSyncListMsg;

    //cocos
    @property(cc.Prefab)
    protected pLb: cc.Prefab = null;
    @property(cc.Label)
    protected lbFrame: cc.Label = null;
    @property(cc.Node)
    ndLeft: cc.Node = null;
    @property(cc.Node)
    ndRight: cc.Node = null;
    @property({type: [fpsPlayer], displayName: '玩家们'})
    protected players: fpsPlayer[] = [];

    onLoad() {
        managers().socketMgr.registerGameClient(this);
    }

    start() {
        const msg = new CSubMatchRoom('');
        this.sendGameMessage(msg.getPackageBody(this.gameId));
        this.lbFrame.string = '匹配队友……';
        this.onRegisterTouch();
    }

    protected onRegisterTouch() {
        this.ndLeft.on('touchstart', this.onTouchStart.bind(this, Direction.LEFT));
        this.ndRight.on('touchstart', this.onTouchStart.bind(this, Direction.RIGHT));
        this.ndLeft.on('touchend', this.onTouchEnd.bind(this, Direction.LEFT));
        this.ndLeft.on('touchcancel', this.onTouchEnd.bind(this, Direction.LEFT));
        this.ndRight.on('touchend', this.onTouchEnd.bind(this, Direction.RIGHT));
        this.ndRight.on('touchcancel', this.onTouchEnd.bind(this, Direction.RIGHT));
        //
        cc.systemEvent.on(cc.SystemEvent.EventType.KEY_DOWN, this.onKeyDown, this);
        cc.systemEvent.on(cc.SystemEvent.EventType.KEY_UP, this.onKeyUp, this);
    }

    protected onKeyDown(event: cc.Event.EventKeyboard) {
        switch (event.keyCode) {
            case cc.macro.KEY.a:
            case cc.macro.KEY.left: {
                this.onTouchStart(Direction.LEFT);
                break;
            }
            case cc.macro.KEY.d:
            case cc.macro.KEY.right: {
                this.onTouchStart(Direction.RIGHT);
                break;
            }
            case cc.macro.KEY.j: {
                this.onBtnJump();
                break;
            }
        }
    }

    protected onKeyUp(event: cc.Event.EventKeyboard) {
        switch (event.keyCode) {
            case cc.macro.KEY.a:
            case cc.macro.KEY.left: {
                this.onTouchEnd(Direction.LEFT);
                break;
            }
            case cc.macro.KEY.d:
            case cc.macro.KEY.right: {
                this.onTouchEnd(Direction.RIGHT);
                break;
            }
        }
    }

    protected onTouchStart(dir: Direction) {
        let sync = FpsSync.NULL;
        if (dir == Direction.LEFT) {
            sync = FpsSync.LEFT_DOWN;
        } else if (dir == Direction.RIGHT) {
            sync = FpsSync.RIGHT_DOWN;
        }
        if (sync) {
            const msg = new SyncMessage(undefined, sync);
            this.sendGameMessage(msg.getPackageBody());
        }
    }

    protected onTouchEnd(dir: Direction) {
        let sync = FpsSync.NULL;
        if (dir == Direction.LEFT) {
            sync = FpsSync.LEFT_UP;
        } else if (dir == Direction.RIGHT) {
            sync = FpsSync.RIGHT_UP;
        }
        if (sync) {
            const msg = new SyncMessage(undefined, sync);
            this.sendGameMessage(msg.getPackageBody());
        }
    }

    protected onBtnJump() {
        const msg = new SyncMessage(undefined, FpsSync.JUMP);
        this.sendGameMessage(msg.getPackageBody());
    }


    //net start go
    protected onStartGo(dir: Direction, player: fpsPlayer) {
        player.getComO1Box().setGoDirection(dir);
    }

    //net end go
    protected onEndGo(dir: Direction, player: fpsPlayer) {
        if (player.getComO1Box().getGoDirection() == dir) {
            player.getComO1Box().setGoDirection(null);
        }
    }

    //net jump
    protected onJump(player: fpsPlayer) {
        player.onJump();
    }

    protected getMePlayer() {
        return this.players[this.m_mePlayerSeat];
    }

    protected getPlayerOfSeat(i: number) {
        return this.players[i];
    }

    update(dt) {

    }
}



































